module.exports = __webpack_public_path__ + "assets/cd50e2371945feca18734a6c78bd2ff7.png";